import "./IconDropdownCarrot.scss";

type Props = {
  open: boolean;
  color?: "black" | "blue";
};
export const IconDropdownCarrot = ({ open = false, color = "black" }: Props) => {
  return <span className={`icon-dropdown-carrot icon-dropdown-carrot-${color}  ${open ? "open" : ""}`}></span>;
};
